import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

/** Gold-topped ring spinner (mockup `.spinner`). */
export default function Spinner({ size = 'sm', className }: { size?: 'sm' | 'md'; className?: string }) {
  const { t } = useTranslation();
  return (
    <span
      role="status"
      aria-label={t('state.working')}
      className={cn(
        'inline-block shrink-0 animate-spin rounded-full border-2 border-track border-t-primary',
        size === 'md' ? 'h-[22px] w-[22px]' : 'h-4 w-4',
        className,
      )}
    />
  );
}
